import { render, staticRenderFns } from "./PagoEfectivoForm.vue?vue&type=template&id=35a115c0&scoped=true&"
import script from "./PagoEfectivoForm.vue?vue&type=script&lang=js&"
export * from "./PagoEfectivoForm.vue?vue&type=script&lang=js&"
import style0 from "./PagoEfectivoForm.vue?vue&type=style&index=0&id=35a115c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a115c0",
  null
  
)

export default component.exports